import { useCallback, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { closeModal, openModal } from '@app/redux/modal';

import { AddressFormFields } from './Address.constants';
import StoreSwitchModal from './StoreSwitchModal';

const useStoreSwitch = (
  initialCountryCode: string,
  selectedCountryCode: string,
  namespace: string,
): void => {
  const dispatch = useDispatch();
  const { setValue } = useFormContext();

  const setInitialCountryCode = useCallback(() => {
    setValue(`${namespace}.${AddressFormFields.Country}`, initialCountryCode);
  }, [initialCountryCode, namespace, setValue]);

  const openStoreSwitchModal = useCallback(
    () =>
      dispatch(
        openModal({
          label: 'store-switch-modal',
          content: (
            <StoreSwitchModal
              country={selectedCountryCode}
              onClose={() => {
                setInitialCountryCode();
                dispatch(closeModal());
              }}
            />
          ),
        }),
      ),
    [dispatch, selectedCountryCode, setInitialCountryCode],
  );

  useEffect(() => {
    if (initialCountryCode !== selectedCountryCode) {
      openStoreSwitchModal();
    }
  }, [selectedCountryCode, initialCountryCode, openStoreSwitchModal]);
};

export default useStoreSwitch;
